import { Factory } from '@team/factory';
import { BaseLogger } from './interfaces';

export const Container = Factory.createContainer<{
  logger: BaseLogger;
}>('Logger');
